import { render } from "./SJinventory.vue?vue&type=template&id=07d1f9bc&scoped=true"
import script from "./SJinventory.vue?vue&type=script&lang=js"
export * from "./SJinventory.vue?vue&type=script&lang=js"

import "./SJinventory.vue?vue&type=style&index=0&id=07d1f9bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07d1f9bc"

export default script